/* eslint-disable */
import { createSelector } from 'reselect';
import getFiltersAddresses from './FiltersAddresses.selector';

/**
 * Selects the selected `addresses` from `filters`
 * @returns {any} The addresses
 */
const getFiltersSelectedAddresses = createSelector(getFiltersAddresses, (addresses) => {
  return Object.entries(addresses)
    .filter(([address, isSelected]) => isSelected)
    .map(([address, isSelected]) => address);
});

export default getFiltersSelectedAddresses;
